import React from "react";
import "./style.css"

const ReadOnlyRow = ({
  isLoadingDelete,
  contact,
  handleEditClick,
  handleDeleteClick,
  handleDownloadRow
}) => {
  return (
    <tr className="trrows hover-red bg-white ">
      <td className="bg-gold">{contact.id}</td>
      <td>{contact.farmerid}</td>
      <td>{contact.producttype}</td>
      <td>{contact.weight}</td>
      <td>{contact.companyname}</td>
      <td>{contact.fullname}</td>
      <td>{contact.daterecorded}</td>

      <td>
   
          <label className="pa4 hover-bg-transparent"onClick={(event) => handleEditClick(event, contact)}>
            <i className="fas fa-edit f2 hover-gold"></i>
            <span className="ml2"></span>
          </label>
   
    
         <label className="pa4 hover-bg-transparent"  onClick={() => handleDownloadRow(contact)}>
            <i className="fas fa-download f2 hover-yellow green"></i>
            <span className="ml2"></span>
          </label>
         <label className="pa4 hover-bg-transparent"  onClick={() => handleDeleteClick(contact.id)}>
            <i className="fas fa-trash f2 hover-yellow red"></i>
            <span className="ml2"></span>
          </label>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
